// extracted by mini-css-extract-plugin
module.exports = {"icon":"WalletListItem_icon__3TnSi","error":"WalletListItem_error__E0PLR","text":"WalletListItem_text__3qSz8"};